<template>
    <div id="wsbx">
        <headTop :id="id" @topback="topback"></headTop>
        <detailTop :name="name" :text="text" :detailid="detailid"></detailTop>
        <detailBread :breadName="breadName"></detailBread>
        <div class="wsbxContent">
            <div class="wsbxContent_">
                <div class="wsbxContent_1 clearfix">
                    <div class="left">
                        <h3><span>业务流程（PC端/手机端）</span> <i class="wsbxh1"></i></h3>
                        <div class="left_text">
                            <p>1.报修、录单</p>
                            <p>2.办理、派单</p>
                            <p>3.维修完工</p>
                            <p>4.评价确认</p>
                        </div>
                    </div>
                    <div class="right"></div>
                </div>
                <div class="wsbxContent_2">
                    <div class="left"></div>
                    <div class="right">
                        <h3><span>智能服务</span> <i class="wsbxh2"></i></h3>
                        <div class="left_text">
                            <p>从后勤报修服务扩展到全校各类型 <br> 报修服务；</p>
                            <p>根据不同报修区域，智能化派单到<br>各维修单位</p>
                        </div>
                    </div>
                </div>
                <div class="wsbxContent_3">
                    <div class="left">
                        <h3><span>不同的管理方式</span> <i class="wsbxh3"></i></h3>
                        <div class="left_text">
                            后端的内部管理与前端的业务流程分割 ，<br>既适应不同的管理方式，又提供全面、便 <br>捷的报修服务。
                        </div>
                    </div>
                    <div class="right"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import headTop from '@/components/headTop'
import detailTop from '@/components/detailTop'
import detailBread from '@/components/detailBread'
export default {
    metaInfo: {
        title: '网上报修', // set a title
        meta: [{             // set meta
            name: 'keyWords',
            content: '网上报修,在线报修,在线报修管理,在线报修平台,在线报修管理系统,后勤线上报修平台,后勤网上报修,后勤网上报修系统'
        },
        {
            name: 'description',
            content: '网上报修,在线报修,在线报修管理,在线报修平台,在线报修管理系统,后勤线上报修平台,后勤网上报修,后勤网上报修系统'
        }],
    },
    components:{
        detailTop,
        detailBread,
        headTop
    },
    data() {
        return {
            id:'1',
            detailid:0,
            name:'网上报修平台',
            text:'覆盖全校区域的全面报修，智能分配各维修单位，电话报修的快速录单，实现了全校各类故障的快速及便捷的报修；实现报修单的责任到人；实现报修、维修、确认的闭环流程。',
            breadName:'网上报修平台'
        }
    },
    // beforeRouteEnter:(to,from,next)=>{
    //     console.log('tag', to,from,next)
    //     if(to.fullPath.indexOf('?') !=-1){
    //         location.href = to.fullPath.replace("?","&")
    //     }
    //     next(vm=>{
    //     })
    // },
    methods: {
        topback(){
            this.$router.push({
                path:'/',
            })
        }
    },
    mounted() {
        $('html,body').animate({
            scrollTop: 0 + "px"
        }, {
            duration: 0,
            easing: "swing"
        });
        return false;
    },
    
}
</script>


// WEBPACK FOOTER //
// src/pages/wsbx.vue